import React, { useEffect, useRef, useState } from "react";
import 'jspdf';
import autoTable from 'jspdf-autotable';
import jsPDF from "jspdf";
import { TextField, MenuItem, Select, InputLabel, FormControl, Button, Grid, Box, Container, Autocomplete } from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";
import { useDispatch, useSelector } from "react-redux";
import { enqueueSnackbar } from "notistack";
import { DropdownChangeEvent } from "primereact/dropdown";
import * as XLSX from "xlsx";
import { PAGESTART, PAGESEND } from "../../api/endpoint";
import { CustomMessage } from "../../const/Spinner";
import { setLoading } from "../../store/CommonSlice";
import { RootState } from "../../store/Reduxstore";
import { IndentFormData, Row, Section } from "../../types/assetTypes";
import { getIndentByIdData, handleInternalAsset, handleExternalAsset, getUniqueAssetNamesByFamilyId, createIndentTemplate, updateIndentTemplate, getIndentTemplateByIdData, getUniqueExtAssetNamesByFamilyId, getUniqueIntAssetNamesByFamilyId, handleToolAsset, getUniqueToolsAssetNamesByFamilyId, getIntAssetLocalCodesByFamilyId, getExtAssetLocalCodesByFamilyId, getToolsAssetLocalCodesByFamilyId } from "../../api/Services/assetServices";
import { getFamilyAssetMasterDataList, getLocalStoreMasterDataList } from "../../api/Services/masterServie";
import { getListOfStock, getStockCodesByCategory } from "../../api/Services/stockService";


interface CreatetTemplateProps {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  indentTemplateId: number | null;
  setIndentTemplateId: React.Dispatch<React.SetStateAction<number | null>>;
  userId: number;

}

type StockOption = {
  label: string;
  value: string;
  name: {
    stockCode: string;
    stock_description: string;
    currentStock: number;
  };
};

const mapStockOptions = (items: any[] = []): StockOption[] =>
  items.map((item) => ({
    label: `${item.stock_code} - ${item.stock_description || ""}`,
    value: item.stockCodeId.toString(),
    name: {
      stockCode: item.stock_code,
      stock_description: item.stock_description ?? "",
      currentStock: item.current_stock ?? 0,
    },
  }));

type AssetLocalOption = {
  assetName: string;
  localCode: string;
};

const mapAssetLocalOptions = (items: any[] = []): AssetLocalOption[] =>
  items.map((item) => ({
    assetName: item.assetName ?? "",
    localCode: item.localCode ?? "",
  }));

const tableAutocompleteSx = {
  width: "100%",
  "& .MuiOutlinedInput-root": {
    minHeight: "35px",
    padding: "0 8px",
  },
  "& .MuiAutocomplete-input": {
    padding: "0 !important",
  },
};

declare module 'jspdf' {
  interface jsPDF {
    lastAutoTable?: {
      finalY: number;
    };
  }
}

const CreatingIndents: React.FC<CreatetTemplateProps> = ({ setOpen, indentTemplateId, setIndentTemplateId, userId }) => {
  const userDetails = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();

  const getAssetLocalOptions = async (
    familyAssetId: number,
    sectionTitle: string
  ): Promise<AssetLocalOption[]> => {
    const response =
      sectionTitle === "Tools (internal)"
        ? await getToolsAssetLocalCodesByFamilyId(familyAssetId)
        : sectionTitle === "Main (external)"
        ? await getExtAssetLocalCodesByFamilyId(familyAssetId)
        : await getIntAssetLocalCodesByFamilyId(familyAssetId);

    return response?.status?.code === 200 && Array.isArray(response.data)
      ? mapAssetLocalOptions(response.data)
      : [];
  };


  const [formData, setFormData] = React.useState<IndentFormData>({
    indentTemplateId: 0,
    userId: userDetails?.userId ?? 0,
    username: userDetails?.name ?? "",
    indentId: 0,
    indentNo: 0,
    countryName: "",
    currentLocationId: 0,
    indentPrimaryId: 0,
    requestTo: "",
    requestToId: 0,
    requestFromId: 0,
    requestFrom: "",
    address: "",
    mapLocation: "",
    date: "",
    defaultList: "",
    notify: "",
    notes: "",
    status: 0,
    section: [] as Section[],
    userIds: [],
  });
  interface AssetOption {
    label: string;
    value: string;
  }


  const [families, setfamilies] = useState<
    { label: string; value: string | null }[]
  >([]);

  const [categories, setCategories] = useState<
    { label: string; value: string | null }[]
  >([
    { label: "Electrical", value: "electrical" },
    { label: "Rubber", value: "rubber" },
  ]);

  const [toolsfamilies, settoolsfamilies] = useState<
    { label: string; value: string | null }[]
  >([]);

  const [suppliers, setSuppliers] = useState<
    { label: string; value: string | null }[]
  >([]);

  const [assets, setAssets] = useState<
    { label: string; value: string | null }[]
  >([]);
  //   const [stockCodes, setStockCodes] = useState<
  //   {
  //     label: string;
  //     value: string;
  //     name: {
  //       stockCode: string;
  //       stock_description: string;
  //       currentStock: number;        

  //     };
  //   }[]
  // >([]);  

  useEffect(() => {
    if (families.length === 0) getAssetTypeList(1, PAGESEND);
  }, [families]);

  useEffect(() => {
    if (toolsfamilies.length === 0) getToolsFamiliesList(1, PAGESEND);
  }, [toolsfamilies]);

  //   useEffect(() => {
  //   if (formData.section.length > 0 && stockCodes.length > 0) {
  //     const updatedSections = formData.section.map((sec) => ({
  //       ...sec,
  //       rows: sec.rows.map((row) => {
  //         if (row.stockCodeId) {
  //           const selectedStock = stockCodes.find(
  //             (item) => Number(item.value) === Number(row.stockCodeId)
  //           );

  //           return selectedStock
  //             ? {
  //                 ...row,
  //                 stockCode: selectedStock.name.stockCode,
  //                 stockDescription: selectedStock.name.stock_description,
  //               }
  //             : row;
  //         }
  //         return row;
  //       }),
  //     }));

  //     setFormData((prev) => ({ ...prev, section: updatedSections }));
  //     setData(updatedSections);
  //   }
  // }, [stockCodes, formData.section]);

  // useEffect(() => {
  //   if (!formData.section || formData.section.length === 0) return;
  //   if (!stockCodes || stockCodes.length === 0) return;

  //   const updatedSections = formData.section.map((sec) => ({
  //     ...sec,
  //     rows: sec.rows.map((row) => {
  //       if (row.stockCodeId && row.stockCodeId !== "") {
  //         const selectedStock = stockCodes.find(
  //           (item) => Number(item.value) === Number(row.stockCodeId)
  //         );
  //         return selectedStock
  //           ? {
  //               ...row,
  //               stockCode: selectedStock.name.stockCode,
  //               stockDescription: selectedStock.name.stock_description,
  //             }
  //           : row;
  //       }
  //       return row;
  //     }),
  //   }));

  //   // Only update if something changed to prevent extra renders
  //   setFormData((prev) => {
  //     const isEqual = JSON.stringify(prev.section) === JSON.stringify(updatedSections);
  //     return isEqual ? prev : { ...prev, section: updatedSections };
  //   });
  //   setData(updatedSections);
  // }, [stockCodes]); // 🔹 remove formData.section from deps

  const [intAssets, setIntAssets] = useState<
    { label: string; value: string | null }[]
  >([]);

  const [extAssets, setExtAssets] = useState<
    { label: string; value: string | null }[]
  >([]);


  useEffect(() => {
    if (suppliers.length === 0) getLocalStoreList(1, PAGESEND);
  }, [suppliers]);

  const getAssetTypeList = async (page: number, rows: number) => {
    dispatch(setLoading(true));
    console.log("Fetching asset types...");

    try {
      const { data, status } = await getFamilyAssetMasterDataList(page, rows, {
        familyAssetId: { value: "", matchMode: "startsWith" }
      });

      console.log("Asset type response:", data, status);

      if (status.code === 200 && data?.length > 0) {
        const updatedData: { label: string; value: string | null }[] = data.map((val) => ({
          value: val.familyAssetId.toString(),
          label: val.familyName,
        }));

        updatedData.unshift({ label: "--Select--", value: null });


        console.log("Updated asset type list:", updatedData);

        setfamilies(updatedData);

      }
    } catch (error: any) {
      console.error("Error fetching asset types:", error);
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
      console.log("Asset type fetch completed.");
    }
  };

  useEffect(() => {
    if (suppliers.length === 0) getLocalStoreList(1, PAGESEND);
  }, [suppliers]);

  const getLocalStoreList = async (page: number, rows: number) => {
    dispatch(setLoading(true));
    console.log("Fetching asset types...");

    try {
      const { data, status } = await getLocalStoreMasterDataList(page, rows, {
        familyAssetId: { value: "", matchMode: "startsWith" }
      });

      console.log("Asset type response:", data, status);

      if (status.code === 200 && data?.length > 0) {
        const updatedData: { label: string; value: string | null }[] = data.map((val) => ({
          value: val.localStoreId.toString(),
          label: val.localStore
        }));

        updatedData.unshift({ label: "--Select--", value: null });


        console.log("Updated asset type list:", updatedData);

        setSuppliers(updatedData);

      }
    } catch (error: any) {
      console.error("Error fetching asset types:", error);
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
      console.log("Asset type fetch completed.");
    }
  };

  const [internalfamilies, setinternalfamilies] = useState<
    { label: string; value: string | null }[]
  >([]);

  useEffect(() => {
    if (internalfamilies.length === 0) getInternalAssetTypeList(1, PAGESEND);
  }, [internalfamilies]);

  const getInternalAssetTypeList = async (page: number, rows: number) => {
    dispatch(setLoading(true));
    console.log("Fetching asset types...");

    try {
      const { data, status } = await handleInternalAsset();

      console.log("Asset type response:", data, status);

      if (status.code === 200 && data?.length > 0) {
        const updatedData: { label: string; value: string | null }[] = data.map((val) => ({
          value: val.familyAssetId.toString(),
          label: val.familyName,
        }));

        updatedData.unshift({ label: "--Select--", value: null });


        console.log("Updated asset type list:", updatedData);

        setinternalfamilies(updatedData);

      }
    } catch (error: any) {
      console.error("Error fetching asset types:", error);
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
      console.log("Asset type fetch completed.");
    }
  };

  const [externalfamilies, setexternalfamilies] = useState<
    { label: string; value: string | null }[]
  >([]);

  useEffect(() => {
    if (externalfamilies.length === 0) getExternalAssetTypeList(1, PAGESEND);
  }, [externalfamilies]);

  const getExternalAssetTypeList = async (page: number, rows: number) => {
    dispatch(setLoading(true));
    console.log("Fetching asset types...");

    try {
      const { data, status } = await handleExternalAsset();

      console.log("Asset type response:", data, status);

      if (status.code === 200 && data?.length > 0) {
        const updatedData: { label: string; value: string | null }[] = data.map((val) => ({
          value: val.familyAssetId.toString(),
          label: val.familyName,
        }));

        updatedData.unshift({ label: "--Select--", value: null });


        console.log("Updated asset type list:", updatedData);

        setexternalfamilies(updatedData);

      }
    } catch (error: any) {
      console.error("Error fetching asset types:", error);
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
      console.log("Asset type fetch completed.");
    }
  };

  const getToolsFamiliesList = async (page: number, rows: number) => {
    dispatch(setLoading(true));
    console.log("Fetching asset types...");

    try {
      const { data, status } = await handleToolAsset();

      console.log("Asset type response:", data, status);

      if (status.code === 200 && data?.length > 0) {
        const updatedData: { label: string; value: string | null }[] = data.map((val) => ({
          value: val.familyAssetId.toString(),
          label: val.familyName,
        }));

        updatedData.unshift({ label: "--Select--", value: null });


        console.log("Updated asset type list:", updatedData);

        settoolsfamilies(updatedData);

      }
    } catch (error: any) {
      console.error("Error fetching asset types:", error);
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
      console.log("Asset type fetch completed.");
    }
  };

  const handleCategoryChange = async (sIdx: number, rIdx: number, category: string) => {
    // Step 1: update the category value for that row
    handleChange(sIdx, rIdx, "stockCategory", category);

    // Step 2: skip if no category selected
    if (!category) return;

    try {
      // Step 3: call your API
      const { data, status } = await getStockCodesByCategory(category);

      if (status.code === 200 && Array.isArray(data)) {
        // Step 4: map API data
        const mappedStockCodes = data.map((item: any) => ({
          label: `${item.stock_code} - ${item.stock_description}`,
          value: item.stockCodeId.toString(),
          stockCode: item.stock_code,
          stockDescription: item.stock_description,
          currentStock: item.current_stock,
        }));

        // Step 5: store it only in that specific row
        const updatedData = [...formData.section];
        updatedData[sIdx].rows[rIdx].stockCodes = mappedStockCodes;

        setFormData({ ...formData, section: updatedData });
      }
    } catch (err) {
      console.error("❌ Error fetching stock codes by category:", err);
    }
  };



  useEffect(() => {
    console.log("Internal families updated:", internalfamilies);
  }, [internalfamilies]);

  useEffect(() => {
    console.log("External families updated:", externalfamilies);
  }, [externalfamilies]);

  useEffect(() => {
    console.log("Tools families updated:", toolsfamilies);
  }, [toolsfamilies]);


  const getAssetNameList = async (
    familyAssetId: number
  ): Promise<{ label: string; value: string }[]> => {
    console.log("Fetching asset names for familyAssetId:", familyAssetId);

    dispatch(setLoading(true));
    try {
      const { data, status } = await getUniqueAssetNamesByFamilyId(familyAssetId);
      console.log("API Response:", { data, status });

      if (status.code === 200 && Array.isArray(data) && data.length > 0) {
        console.log("Raw assetName data:", data);

        const updatedData: { label: string; value: string }[] = data.map(
          (assetName: string) => ({
            value: assetName,
            label: assetName,
          })
        );
        updatedData.unshift({ label: "--Select--", value: "" });

        console.log("Processed Asset Name List:", updatedData);

        setAssets(updatedData);
        return updatedData; // ✅ return
      }
    } catch (error: any) {
      console.error("Error fetching asset names:", error);
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
      console.log("Loading state set to false");
    }

    // ✅ fallback return (never undefined)
    return [{ label: "--Select--", value: "" }];
  };

  const getExtAssetNameList = async (
    familyAssetId: number
  ): Promise<{ label: string; value: string }[]> => {
    console.log("Fetching asset names for familyAssetId:", familyAssetId);

    dispatch(setLoading(true));
    try {
      const { data, status } = await getUniqueExtAssetNamesByFamilyId(familyAssetId);
      console.log("API Response:", { data, status });

      if (status.code === 200 && Array.isArray(data) && data.length > 0) {
        console.log("Raw assetName data:", data);

        const updatedData: { label: string; value: string }[] = data.map(
          (assetName: string) => ({
            value: assetName,
            label: assetName,
          })
        );
        updatedData.unshift({ label: "--Select--", value: "" });

        console.log("Processed Asset Name List:", updatedData);

        setExtAssets(updatedData);
        return updatedData; // ✅ return
      }
    } catch (error: any) {
      console.error("Error fetching asset names:", error);
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
      console.log("Loading state set to false");
    }

    // ✅ fallback return
    return [{ label: "--Select--", value: "" }];
  };

  const getToolAssetNameList = async (
    familyAssetId: number
  ): Promise<{ label: string; value: string }[]> => {
    console.log("Fetching asset names for familyAssetId:", familyAssetId);

    dispatch(setLoading(true));
    try {
      const { data, status } = await getUniqueToolsAssetNamesByFamilyId(familyAssetId);
      console.log("API Response:", { data, status });

      if (status.code === 200 && Array.isArray(data) && data.length > 0) {
        console.log("Raw assetName data:", data);

        const updatedData: { label: string; value: string }[] = data.map(
          (assetName: string) => ({
            value: assetName,
            label: assetName,
          })
        );
        updatedData.unshift({ label: "--Select--", value: "" });

        console.log("Processed Asset Name List:", updatedData);

        setExtAssets(updatedData);
        return updatedData; // ✅ return
      }
    } catch (error: any) {
      console.error("Error fetching asset names:", error);
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
      console.log("Loading state set to false");
    }

    // ✅ fallback return
    return [{ label: "--Select--", value: "" }];
  };

  const getIntAssetNameList = async (
    familyAssetId: number
  ): Promise<{ label: string; value: string }[]> => {
    console.log("Fetching asset names for familyAssetId:", familyAssetId);

    dispatch(setLoading(true));
    try {
      const { data, status } = await getUniqueIntAssetNamesByFamilyId(familyAssetId);
      console.log("API Response:", { data, status });

      if (status.code === 200 && Array.isArray(data) && data.length > 0) {
        const updatedData: { label: string; value: string }[] = data.map(
          (assetName: string) => ({
            value: assetName,
            label: assetName,
          })
        );
        updatedData.unshift({ label: "--Select--", value: "" });

        setIntAssets(updatedData);
        return updatedData; // ✅ always return array
      }
    } catch (error: any) {
      console.error("Error fetching asset names:", error);
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
      console.log("Loading state set to false");
    }

    // ✅ fallback return so TS never sees undefined
    return [{ label: "--Select--", value: "" }];
  };

  const sections: Section[] = [
    { title: 'Main (internal)', rows: [] },
    { title: 'Main (external)', rows: [] },
    { title: 'Tools (internal)', rows: [] },
    { title: 'Stores Consumables', rows: [] },
    { title: 'General Consumables', rows: [] },
  ];
  const [data, setData] = useState<Section[]>(sections);
  const sectionRefs = useRef<(HTMLDivElement | null)[]>([]);
  const [selectedSectionIdx, setSelectedSectionIdx] = useState<number | null>(null);

  useEffect(() => {
    const updatedData = data.map((section) => ({
      ...section,
      rows: section.rows.length > 0 ? section.rows : [
        {
          familyAssetId: 0,
          familyName: "",
          assetName: '',
          description: '',
          localStoreId: 0,
          localStore: "",
          comment: '',
          stockCodeId: "",
          stockCode: "",
          stockDescription: "", issued: 0, pending: 0,
          qty: 0,
          dateReqd: null,
          stockCategory: "",
        }
      ],
    }));
    setData(updatedData);
  }, []);

  const handleAddRow = (sectionIndex: number) => {
    const newRow: Row = {
      familyAssetId: 0,
      familyName: "",
      assetName: '',
      description: '',
      localStoreId: 0,
      localStore: "",
      comment: '',
      qty: 0,
      stockCodeId: "",
      stockCode: "",
      stockDescription: "", issued: 0, pending: 0,
      stockCategory: "",

      dateReqd: null,
    };
    const updated = [...data];
    updated[sectionIndex].rows.push(newRow);
    setData(updated);
  };

  const handleAssetName = (
    sectionIndex: number,
    rowIndex: number,
    field: keyof Row,
    selectedValue: string
  ) => {
    const selectedAsset = assets.find(a => a.value?.toString() === selectedValue);

    const assetName: string = selectedAsset?.label ?? '';


    // Save the value (for the select input) and the label (as assetName)

    handleChange(sectionIndex, rowIndex, 'assetName', assetName);
  };

  const handleSelectFamilyChange = async (
    sectionIndex: number,
    rowIndex: number,
    selectedValue: string,
    sectionTitle: string
  ) => {
    const familyList =
      sectionTitle === "Main (internal)"
        ? internalfamilies
        : sectionTitle === "Main (external)"
          ? externalfamilies
          : sectionTitle === "Tools (internal)"
            ? toolsfamilies
            : families;

    const selectedFamily = familyList.find(fam => String(fam.value) === selectedValue);

    if (!selectedFamily) return;

    const familyName = selectedFamily.label;
    const familyAssetId = Number(selectedFamily.value);

    // Update family info in row
    handleChange(sectionIndex, rowIndex, "familyName", familyName);
    handleChange(sectionIndex, rowIndex, "familyAssetId", familyAssetId);

    // Fetch assets for this row only
    let assetOptions: AssetLocalOption[] = [];

    try {
      assetOptions = await getAssetLocalOptions(familyAssetId, sectionTitle);
    } catch (error) {
      console.error("Error fetching asset names:", error);
    }

    // Store asset options only in this row
    setData((prev) => {
      const updatedSections = [...prev];
      const updatedRows = [...updatedSections[sectionIndex].rows];

      updatedRows[rowIndex] = {
        ...updatedRows[rowIndex],
        assetName: "",
        description: "",
        availableAssets: assetOptions,
      };

      updatedSections[sectionIndex] = {
        ...updatedSections[sectionIndex],
        rows: updatedRows,
      };

      return updatedSections;
    });
  };
  const handleLocalStoreChange = (sectionIndex: number, rowIndex: number, selectedIndex: number) => {
    const selectedStore = suppliers[selectedIndex];

    const localStore: string = selectedStore.label ?? '';
    const localStoreIdStr: string = selectedStore.value?.toString() ?? '';

    // Call handleChange to update as string
    handleChange(sectionIndex, rowIndex, 'localStore', localStore);
    handleChange(sectionIndex, rowIndex, 'localStoreId', localStoreIdStr);

    // Convert to number safely and pass to getAssetNameList

  };




  const handleChange = (
    sectionIndex: number,
    rowIndex: number,
    field: keyof Row,
    value: any
  ) => {
    setData(prevData => {
      const updatedData = [...prevData]; // shallow copy of sections
      const updatedSection = { ...updatedData[sectionIndex] }; // copy of one section
      const updatedRows = [...updatedSection.rows]; // copy of rows
      const updatedRow = { ...updatedRows[rowIndex], [field]: value }; // copy and update one row

      updatedRows[rowIndex] = updatedRow;
      updatedSection.rows = updatedRows;
      updatedData[sectionIndex] = updatedSection;
      console.log("d", data);

      return updatedData;

    });
  };


  const handleSubmit = async (status: number) => {
    const finalData: IndentFormData = {
      ...formData,
      section: data,
      status: status,
    };

    dispatch(setLoading(true));

    try {
      let response;

      // Create or update based on indentId
      if (!finalData.indentTemplateId || finalData.indentTemplateId === 0) {
        response = await createIndentTemplate(finalData);
      } else {
        response = await updateIndentTemplate(finalData);
      }

      const statusCode = response.status;
      const statusMessage = response.data?.status?.message;

      if (statusCode === 201 || statusCode === 200) {
        CustomMessage("Indent saved successfully", "success", enqueueSnackbar);
        setOpen(false);

      }

      else {
        CustomMessage("Failed to save indent", "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message || "Something went wrong", "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleCancel = async () => {
    setOpen(false);
  };

  const handleScrollTo = (idx: number) => {
    setSelectedSectionIdx(idx);
    sectionRefs.current[idx]?.scrollIntoView({ behavior: 'smooth' });
  };

  type Filters = {
    [key: string]: {
      value: string[]; // <- expects an array
    };
  };

  const updateRow = (
    sectionIndex: number,
    rowIndex: number,
    updater: (row: Row) => Row
  ) => {
    setData((prevData) => {
      const updatedData = [...prevData];
      const updatedSection = { ...updatedData[sectionIndex] };
      const updatedRows = [...updatedSection.rows];

      updatedRows[rowIndex] = updater(updatedRows[rowIndex]);
      updatedSection.rows = updatedRows;
      updatedData[sectionIndex] = updatedSection;

      return updatedData;
    });
  };

  const onFetchData = async (
    stockCategory: string,
    sectionIndex: number,
    rowIndex: number
  ) => {
    updateRow(sectionIndex, rowIndex, (row) => ({
      ...row,
      stockCategory,
      stockCodeId: "",
      stockCode: "",
      stockDescription: "",
      currentStock: 0,
      stockOptions: [],
    }));

    if (!stockCategory) return;

    dispatch(setLoading(true));
    try {
      const response = await getStockCodesByCategory(stockCategory);
      const { data, status } = response;
      const stockOptions = status.code === 200 && Array.isArray(data)
        ? mapStockOptions(data)
        : [];

      updateRow(sectionIndex, rowIndex, (row) => ({
        ...row,
        stockOptions,
      }));
    } catch (error: any) {
      console.error(error);
      CustomMessage(error?.message || "Failed to fetch stock codes", "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };




  //   const onFetchData = async (stockCategory: string) => {
  //   if (!stockCategory) return setStockCodes([]); // clear if empty

  //   dispatch(setLoading(true));
  //   try {
  //     const response = await getStockCodesByCategory(stockCategory);
  //     const { data, status } = response;

  //     if (status.code === 200 && data?.length > 0) {
  //       const mappedStockCodes = data.map((item) => ({
  //         label: `${item.stock_code} - ${item.stock_description || ""}`,
  //         value: item.stockCodeId.toString(),
  //         name: {
  //           stockCode: item.stock_code,
  //           stock_description: item.stock_description ?? "",
  //           currentStock: item.current_stock ?? 0,
  //         },
  //       }));

  //       setStockCodes(mappedStockCodes);
  //     } else {
  //       setStockCodes([]);
  //     }
  //   } catch (error: any) {
  //     console.error(error);
  //     CustomMessage(error?.message || "Failed to fetch stock codes", "error", enqueueSnackbar);
  //   } finally {
  //     dispatch(setLoading(false));
  //   }
  // };





  const handleSelectStockChange = (
    stockCodeId: string,
    sectionIndex: number,
    rowIndex: number
  ) => {
    updateRow(sectionIndex, rowIndex, (row) => {
      const selected = (row.stockOptions || []).find(
        (item: StockOption) => item.value === stockCodeId
      );

      return {
        ...row,
        stockCodeId,
        stockCode: selected?.name.stockCode ?? "",
        stockDescription: selected?.name.stock_description ?? "",
        currentStock: selected?.name.currentStock ?? 0,
      };
    });
  };

  const handleSelectAssetLocalChange = (
    selectedAssetName: string,
    sectionIndex: number,
    rowIndex: number
  ) => {
    updateRow(sectionIndex, rowIndex, (row) => {
      const selected = (row.availableAssets || []).find(
        (item: AssetLocalOption) => item.assetName === selectedAssetName
      );

      return {
        ...row,
        assetName: selected?.assetName ?? "",
        description: selected?.localCode ?? "",
      };
    });
  };



  const blankRow: Row = {
    familyAssetId: 0,
    familyName: '',
    assetName: '',
    localStoreId: 0,
    localStore: '',
    description: '',
    stockCodeId: "",
    stockCode: "",
    stockDescription: "", issued: 0, pending: 0,
    comment: '',
    qty: 0,
    dateReqd: null,
    stockCategory: "",
  };

  useEffect(() => {
    // Initialize the first section (Main internal) to be selected on initial load
    setSelectedSectionIdx(0);

    const updatedData = data.map((section) => ({
      ...section,
      rows: section.rows.length > 0 ? section.rows : [blankRow],
    }));
    setData(updatedData);
  }, []);


  const handleDeleteRow = (sectionIndex: number, rowIndex: number) => {
    const updated = [...data];
    updated[sectionIndex].rows.splice(rowIndex, 1); // Remove the row
    setData(updated);
  };

  useEffect(() => {
    if (indentTemplateId !== null && indentTemplateId != 0) {
      getDataById();
    }
  }, [indentTemplateId]);



  const getDataById = async () => {
    if (!indentTemplateId) return;

    setLoading(true);

    try {
      const response = await getIndentTemplateByIdData(indentTemplateId);

      if (response.data) {
        const { section, ...otherIndentData } = response.data;

        // Map each section and row
        const updatedSections = await Promise.all(
          (section || []).map(async (sec) => {
            const updatedRows = await Promise.all(
              sec.rows.map(async (row) => {
                let enrichedRow = { ...row };

                // 🔹 Handle stockCategory rows (consumables)
                if (row.stockCategory) {
                  const stockResponse = await getStockCodesByCategory(row.stockCategory);
                  const stockOptions = mapStockOptions(stockResponse.data);

                  enrichedRow.stockOptions = stockOptions;

                  if (row.stockCodeId) {
                    const selectedStock = stockOptions.find(
                      (s) => Number(s.value) === Number(row.stockCodeId)
                    );
                  if (selectedStock) {
                    enrichedRow.stockCodeId = selectedStock.value;
                    enrichedRow.stockCode = selectedStock.name.stockCode;
                    enrichedRow.stockDescription = selectedStock.name.stock_description;
                    enrichedRow.currentStock = selectedStock.name.currentStock;
                  }
                  }
                }

                // 🔹 Handle availableAssets for non-consumable sections
                if (row.familyAssetId && row.familyAssetId > 0) {
                  const assetOptions = await getAssetLocalOptions(row.familyAssetId, sec.title);
                  const selectedAsset = assetOptions.find(
                    (item) => item.assetName === row.assetName || item.localCode === row.description
                  );

                  enrichedRow.assetName = selectedAsset?.assetName ?? row.assetName ?? "";
                  enrichedRow.description = selectedAsset?.localCode ?? row.description ?? "";
                  enrichedRow.availableAssets = assetOptions;
                }

                return enrichedRow;
              })
            );

            return { ...sec, rows: updatedRows };
          })
        );

        // Update full state
        const updatedFormData = {
          ...formData,
          ...otherIndentData,
          section: updatedSections,
        };

        setFormData(updatedFormData);
        setData(updatedSections);

        console.log("Final updatedSections:", updatedSections);
      }

      setIndentTemplateId(null);
    } catch (error: any) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  // const getDataById = async () => {
  //   if (!indentTemplateId) return;

  //   setLoading(true);

  //   try {
  //     const response = await getIndentTemplateByIdData(indentTemplateId);       

  //     if (response.data) {
  //       const { section, ...otherIndentData } = response.data;

  //       const updatedFormData = {
  //         ...formData,
  //         ...otherIndentData,
  //         section: section || [],
  //       };

  //       const updatedSections = updatedFormData.section.map((sec) => ({
  //        ...sec,
  //         rows: sec.rows.map((row) => {
  //           if (row.stockCodeId) {
  //             const selectedStock = stockCodes.find(
  //               (item) => Number(item.value) === Number(row.stockCodeId)
  //             );

  //             if (selectedStock) {
  //               return {
  //                 ...row,
  //                 stockCodeId: selectedStock.value,
  //                 stockCode: selectedStock.name.stockCode,
  //                 stockDescription: selectedStock.name.stock_description,
  //               };
  //             }
  //           }
  //           return row;
  //         }),
  //       }));

  //       setFormData({
  //         ...updatedFormData,
  //         section: updatedSections,
  //       });
  //       setData(updatedSections);
  //       console.log("Form data set with:", updatedFormData);
  //       console.log("Updated sections after stockCodeId handling:", updatedSections);


  //         if (updatedSections.length > 0) {
  //           for (let sIdx = 0; sIdx < updatedSections.length; sIdx++) {
  //             const sec = updatedSections[sIdx];

  //             for (let rIdx = 0; rIdx < sec.rows.length; rIdx++) {
  //               const row = sec.rows[rIdx];

  //               if (row.familyAssetId && row.familyAssetId > 0) {
  //                 let assetOptions: { label: string; value: string }[] = [];

  //                 if (sec.title === "Main (internal)" || sec.title === "Tools (internal)") {
  //                   assetOptions = await getIntAssetNameList(Number(row.familyAssetId));
  //                 } else if (sec.title === "Main (external)") {
  //                   assetOptions = await getExtAssetNameList(Number(row.familyAssetId));
  //                 } else {
  //                   assetOptions = await getAssetNameList(Number(row.familyAssetId));
  //                 }

  //                 // ✅ Inject availableAssets directly into the row
  //                 updatedSections[sIdx].rows[rIdx] = {
  //                   ...row,
  //                   availableAssets: assetOptions,
  //                 };
  //               }
  //             }
  //           }
  //         }

  //       }        

  //     setIndentTemplateId(null);
  //   } catch (error: any) {
  //     console.error("Error fetching data:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const defaultHeaders = [
    'Family',
    'Asset Number',
    'Description',
    'Supplier',
    'Spec / Comment',
    'Qty',
    'Date Reqd',
    'Actions',
  ];

  const renderTableHeaders = (sectionTitle: string) => {
    return defaultHeaders.map((header, idx) => {
      // Handle replacements for specific sections
      if (['Stores Consumables', 'General Consumables'].includes(sectionTitle)) {
        if (header === 'Family') {
          return (
            <th key={idx} style={{ border: '1px solid #ddd', padding: '8px' }}>
              Category
            </th>
          );
        }
        if (header === 'Asset Number') {
          return (
            <th key={idx} style={{ border: '1px solid #ddd', padding: '8px' }}>
              Stock Code
            </th>
          );
        }
        if (header === 'Description') {
          return (
            <th key={idx} style={{ border: '1px solid #ddd', padding: '8px' }}>
              Stock Description
            </th>
          );
        }
      }

      // Default case
      return (
        <th key={idx} style={{ border: '1px solid #ddd', padding: '8px' }}>
          {header}
        </th>
      );
    });
  };

  return (

    <div className="p-6">
      <Container maxWidth="lg">
        <Grid container spacing={3}
          justifyContent="center"
        >
        </Grid>
        <div
          style={{
            backgroundColor: '#fff3e0',
            padding: '20px',
            borderRadius: '8px',
            marginTop: '20px'
          }}
        >
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '20px',
            gap: '10px' // spacing between label and input
          }}>
            <label style={{
              fontWeight: 'bold',
              fontSize: '16px',
              minWidth: '180px', // adjust based on how long your label is
              textAlign: 'right'
            }}>
              Indent Template Name:
            </label>
            <input
              type="text"
              value={formData.indentTemplateName}
              onChange={(e) => setFormData({ ...formData, indentTemplateName: e.target.value })}
              placeholder="Enter template name"
              style={{
                width: '300px',
                padding: '10px 12px',
                fontSize: '16px',
                borderRadius: '6px',
                border: '1px solid #ccc',
                backgroundColor: '#fff',
                color: '#2c3e50',
              }}
            />
          </div>

          <div
            style={{
              backgroundColor: "#fff3e0",
              padding: "20px",
              borderRadius: "8px",
              marginTop: "20px",
            }}
          >
            <div>
              {data.map((section, sIdx) => (
                <div
                  key={sIdx}
                  ref={(el) => (sectionRefs.current[sIdx] = el)}
                  style={{
                    border: "1px solid #ccc",
                    marginBottom: "15px",
                    borderRadius: "8px",
                    backgroundColor: "#ffffff",
                    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                  }}
                >
                  <details
                    open={sIdx === 0} // optional: keep first one open by default
                    onClick={() => setSelectedSectionIdx(sIdx)}
                  >
                    <summary
                      style={{
                        padding: '12px 16px',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                      }}
                    >
                      {section.title}
                    </summary>
                    <div style={{ padding: '16px' }}>
                      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                          <tr style={{ height: '50px', backgroundColor: '#f5f5f5' }}>
                            {renderTableHeaders(section.title)}
                          </tr>
                        </thead>
                        <tbody>
                          {section.rows.map((row, rIdx) => (
                            <tr key={rIdx} style={{ height: '80px' }}>
                              {["Stores Consumables", "General Consumables"].includes(section.title) ? (
                                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                                  <Autocomplete
                                    size="small"
                                    sx={tableAutocompleteSx}
                                    options={categories}
                                    value={categories.find((cat) => cat.value === row.stockCategory) || null}
                                    getOptionLabel={(option) => option.label}
                                    isOptionEqualToValue={(option, value) => option.value === value.value}
                                    onChange={(_, newValue) => onFetchData(newValue?.value ?? "", sIdx, rIdx)}
                                    renderInput={(params) => <TextField {...params} placeholder="Select Category" />}
                                  />
                                </td>
                              ) : (
                                // Family dropdown (default)
                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                                  <Autocomplete
                                    size="small"
                                    sx={tableAutocompleteSx}
                                    options={
                                      section.title === "Main (internal)"
                                        ? internalfamilies
                                        : section.title === "Main (external)"
                                          ? externalfamilies
                                          : section.title === "Tools (internal)"
                                            ? toolsfamilies
                                            : families
                                    }
                                    value={(
                                      section.title === "Main (internal)"
                                        ? internalfamilies
                                        : section.title === "Main (external)"
                                          ? externalfamilies
                                          : section.title === "Tools (internal)"
                                            ? toolsfamilies
                                            : families
                                    ).find((fam) => Number(fam.value) === Number(row.familyAssetId)) || null}
                                    getOptionLabel={(option) => option.label}
                                    isOptionEqualToValue={(option, value) => option.value === value.value}
                                    onChange={(_, newValue) => {
                                      if (newValue?.value) {
                                        handleSelectFamilyChange(sIdx, rIdx, newValue.value, section.title);
                                      } else {
                                        updateRow(sIdx, rIdx, (currentRow) => ({
                                          ...currentRow,
                                          familyAssetId: 0,
                                          familyName: "",
                                          assetName: "",
                                          description: "",
                                          availableAssets: [],
                                        }));
                                      }
                                    }}
                                    renderInput={(params) => <TextField {...params} placeholder="Select Family" />}
                                  />
                                </td>
                              )}

                              {['Stores Consumables', 'General Consumables'].includes(section.title) ? (
                                <>
                                  <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                                    <Autocomplete
                                      size="small"
                                      sx={tableAutocompleteSx}
                                      options={row.stockOptions || []}
                                      value={(row.stockOptions || []).find((item: StockOption) => item.value === row.stockCodeId) || null}
                                      getOptionLabel={(option: StockOption) => option.name.stockCode}
                                      isOptionEqualToValue={(option, value) => option.value === value.value}
                                      onChange={(_, newValue) => handleSelectStockChange(newValue?.value ?? "", sIdx, rIdx)}
                                      renderInput={(params) => <TextField {...params} placeholder="Select Stock Code" />}
                                    />
                                  </td>

                                  <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                                    <Autocomplete
                                      size="small"
                                      sx={tableAutocompleteSx}
                                      options={row.stockOptions || []}
                                      value={(row.stockOptions || []).find((item: StockOption) => item.value === row.stockCodeId) || null}
                                      getOptionLabel={(option: StockOption) => option.name.stock_description}
                                      isOptionEqualToValue={(option, value) => option.value === value.value}
                                      onChange={(_, newValue) => handleSelectStockChange(newValue?.value ?? "", sIdx, rIdx)}
                                      renderInput={(params) => <TextField {...params} placeholder="Select Stock Description" />}
                                    />
                                  </td>
                                </>
                              ) : (
                                <>
                                  <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                                    <Autocomplete
                                      size="small"
                                      sx={tableAutocompleteSx}
                                      options={row.availableAssets || []}
                                      value={(row.availableAssets || []).find((a: AssetLocalOption) => a.assetName === row.assetName || a.localCode === row.description) || null}
                                      getOptionLabel={(option: AssetLocalOption) => option.assetName}
                                      isOptionEqualToValue={(option, value) => option.assetName === value.assetName}
                                      onChange={(_, newValue) => handleSelectAssetLocalChange(newValue?.assetName ?? "", sIdx, rIdx)}
                                      renderInput={(params) => <TextField {...params} placeholder="Select Asset Name" />}
                                    />

                                  </td>



                                  <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                                    <Autocomplete
                                      size="small"
                                      sx={tableAutocompleteSx}
                                      options={row.availableAssets || []}
                                      value={(row.availableAssets || []).find((a: AssetLocalOption) => a.assetName === row.assetName || a.localCode === row.description) || null}
                                      getOptionLabel={(option: AssetLocalOption) => option.localCode}
                                      isOptionEqualToValue={(option, value) => option.assetName === value.assetName}
                                      onChange={(_, newValue) => handleSelectAssetLocalChange(newValue?.assetName ?? "", sIdx, rIdx)}
                                      renderInput={(params) => <TextField {...params} placeholder="Select Asset Description" />}
                                    />
                                  </td>
                                </>
                              )}
                              <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                                <Autocomplete
                                  size="small"
                                  sx={tableAutocompleteSx}
                                  options={suppliers}
                                  value={suppliers.find((sup) => String(sup.value ?? "") === String(row.localStoreId ?? "")) || null}
                                  getOptionLabel={(option) => option.label}
                                  isOptionEqualToValue={(option, value) => option.value === value.value}
                                  onChange={(_, newValue) => {
                                    if (newValue) {
                                      const selectedIndex = suppliers.findIndex((sup) => sup.value === newValue.value);
                                      if (selectedIndex >= 0) handleLocalStoreChange(sIdx, rIdx, selectedIndex);
                                    } else {
                                      handleChange(sIdx, rIdx, "localStore", "");
                                      handleChange(sIdx, rIdx, "localStoreId", 0);
                                    }
                                  }}
                                  renderInput={(params) => <TextField {...params} placeholder="Select Local Store" />}
                                />
                              </td>
                              <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                                <input
                                  type="text"
                                  value={row.comment}
                                  onChange={(e) => handleChange(sIdx, rIdx, 'comment', e.target.value)}
                                  style={{ width: '100%', height: '35px' }}
                                />
                              </td>
                              <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                                <input
                                  type="number"
                                  value={row.qty === 0 ? "" : row.qty} // Show empty if 0
                                  onChange={(e) =>
                                    handleChange(
                                      sIdx,
                                      rIdx,
                                      'qty',
                                      e.target.value === "" ? 0 : parseInt(e.target.value)
                                    )
                                  }
                                  style={{ width: '100%', height: '35px' }}
                                />
                              </td>
                              <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                                <input
                                  type="date"
                                  value={row.dateReqd ? new Date(row.dateReqd).toISOString().split('T')[0] : ''}
                                  onChange={(e) =>
                                    handleChange(sIdx, rIdx, 'dateReqd', e.target.value || null)

                                  }
                                  style={{ width: '100%', height: '35px' }}
                                />
                              </td>
                              <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>
                                <button
                                  onClick={() => handleDeleteRow(sIdx, rIdx)}
                                  style={{
                                    backgroundColor: 'transparent',
                                    border: 'none',
                                    color: '#e74c3c',
                                    fontSize: '20px',
                                    cursor: 'pointer',
                                  }}
                                  title="Delete row"
                                >
                                  ✖️
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      <div style={{ textAlign: 'center', marginTop: '15px' }}>
                        <button
                          onClick={() => handleAddRow(sIdx)}
                          style={{
                            width: '100px',
                            height: '30px',
                            backgroundColor: '#1976d2',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                          }}
                        >
                          Add New
                        </button>
                      </div>

                    </div>
                  </details>
                </div>

              ))}
            </div>
            <div style={{ marginTop: '20px', textAlign: 'center' }}>

              {formData.status !== 1 &&
                userDetails.role.some(
                  r => r.roleName === "Admin" || r.roleName === "Indents Write"
                ) && (
                  <button
                    onClick={() => handleSubmit(0)} // Save Draft with status = 0
                    style={{
                      width: '100px',
                      height: '40px',
                      backgroundColor: '#3498db',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '4px',
                      fontSize: '18px',
                      cursor: 'pointer',
                      marginRight: '20px',
                    }}
                  >
                    Save
                  </button>
                )}

              <button
                onClick={() => handleCancel()}
                style={{
                  width: '100px',
                  height: '40px',
                  backgroundColor: '#e74c3c',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '4px',
                  fontSize: '18px',
                  cursor: 'pointer',
                }}
              >
                Cancel
              </button>
            </div>

          </div>
        </div>

      </Container>
    </div>

  );
};

export default CreatingIndents;


